export const FIELD_MAPPINGS = {
    MATERIAL_TYPE: "Material Type",
    SIZE: "Size",
    COLOR_CODE: "Color Code",
    COLOR_NAME: "Color Name",
    MATERIAL_DESCRIPTION: "Material Description",
    QUANTITY: "Quantity",
    QUANTITY_UNIT: "Quantity Unit",
    UNIT_PRICE: "Unit Price",
    QUANTITY_CHANGED: "Quantity Changed",
    REMAINING_QUANTITY: "Remaining Quantity",
    IS_NEW: "Is New",
} as const;